<template>
    <div class="row border-bottom">
        <nav class="navbar navbar-static-top  " role="navigation" style="margin-bottom: 0">
            <div class="navbar-header">
                <a v-on:click="toggleNavBar()" class="navbar-minimalize minimalize-styl-2 btn btn-primary " style="border-color:#fff;"><i class="fa fa-bars"></i> </a>
                <form role="search" class="navbar-form-custom" v-on:submit.prevent="routeToNewOrder()">
                    <div class="form-group" v-if="userRole!=='BRANCH'">
                        <input v-on:keyup="validateContactNumber($event)" style="width: 115%; color:white" type="text" placeholder="Enter Number For new Order..." class="form-control" name="top-search" id="top-search">
                    </div>
                </form>
            </div>
            <ul class="nav navbar-top-links navbar-right">
                <li>
                    <!--<span class="m-r-sm text-muted welcome-message">EASY Call-2-Delivery</span>-->
                </li>
                <!--<li class="dropdown">-->
                    <!--<a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">-->
                        <!--<i class="fa fa-envelope"></i>  <span class="label label-warning">16</span>-->
                    <!--</a>-->
                    <!--<ul class="dropdown-menu dropdown-messages">-->
                        <!--<li>-->
                            <!--<div class="dropdown-messages-box">-->
                                <!--<a href="profile.html" class="pull-left">-->
                                    <!--<img alt="image" class="img-circle" src="img/a7.jpg">-->
                                <!--</a>-->
                                <!--<div class="media-body">-->
                                    <!--<small class="pull-right">46h ago</small>-->
                                    <!--<strong>Mike Loreipsum</strong> started following <strong>Monica Smith</strong>. <br>-->
                                    <!--<small class="text-muted">3 days ago at 7:58 pm - 10.06.2014</small>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</li>-->
                        <!--<li class="divider"></li>-->
                        <!--<li>-->
                            <!--<div class="dropdown-messages-box">-->
                                <!--<a href="profile.html" class="pull-left">-->
                                    <!--<img alt="image" class="img-circle" src="img/a4.jpg">-->
                                <!--</a>-->
                                <!--<div class="media-body ">-->
                                    <!--<small class="pull-right text-navy">5h ago</small>-->
                                    <!--<strong>Chris Johnatan Overtunk</strong> started following <strong>Monica Smith</strong>. <br>-->
                                    <!--<small class="text-muted">Yesterday 1:21 pm - 11.06.2014</small>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</li>-->
                        <!--<li class="divider"></li>-->
                        <!--<li>-->
                            <!--<div class="dropdown-messages-box">-->
                                <!--<a href="profile.html" class="pull-left">-->
                                    <!--<img alt="image" class="img-circle" src="img/profile.jpg">-->
                                <!--</a>-->
                                <!--<div class="media-body ">-->
                                    <!--<small class="pull-right">23h ago</small>-->
                                    <!--<strong>Monica Smith</strong> love <strong>Kim Smith</strong>. <br>-->
                                    <!--<small class="text-muted">2 days ago at 2:30 am - 11.06.2014</small>-->
                                <!--</div>-->
                            <!--</div>-->
                        <!--</li>-->
                        <!--<li class="divider"></li>-->
                        <!--<li>-->
                            <!--<div class="text-center link-block">-->
                                <!--<a href="mailbox.html">-->
                                    <!--<i class="fa fa-envelope"></i> <strong>Read All Messages</strong>-->
                                <!--</a>-->
                            <!--</div>-->
                        <!--</li>-->
                    <!--</ul>-->
                <!--</li>-->
                <li class="dropdown">
                    <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
                        <i class="fa fa-bell"></i>  <span class="label label-primary">{{totalNotificationCount}}</span>
                    </a>
                    <ul class="dropdown-menu dropdown-alerts">
                        <li>
                            <router-link to="/complaints">
                                <div>
                                    <i class="fa fa-headphones fa-fw"></i> {{totalNotificationCount}} Pending Complaints
                                    <!--<span class="pull-right text-muted small">4 minutes ago</span>-->
                                </div>
                            </router-link>
                            <!--<a href="mailbox.html">-->
                                <!---->
                            <!--</a>-->
                        </li>
                        <!--<li class="divider"></li>-->
                        <!--<li>-->
                            <!--<a href="profile.html">-->
                                <!--<div>-->
                                    <!--<i class="fa fa-twitter fa-fw"></i> 3 New Followers-->
                                    <!--<span class="pull-right text-muted small">12 minutes ago</span>-->
                                <!--</div>-->
                            <!--</a>-->
                        <!--</li>-->
                        <!--<li class="divider"></li>-->
                        <!--<li>-->
                            <!--<a href="grid_options.html">-->
                                <!--<div>-->
                                    <!--<i class="fa fa-upload fa-fw"></i> Server Rebooted-->
                                    <!--<span class="pull-right text-muted small">4 minutes ago</span>-->
                                <!--</div>-->
                            <!--</a>-->
                        <!--</li>-->
                        <!--<li class="divider"></li>-->
                        <!--<li>-->
                            <!--<div class="text-center link-block">-->
                                <!--<a href="notifications.html">-->
                                    <!--<strong>See All Alerts</strong>-->
                                    <!--<i class="fa fa-angle-right"></i>-->
                                <!--</a>-->
                            <!--</div>-->
                        <!--</li>-->
                    </ul>
                </li>


                <li>
                    <a href="javascript:void(0)" v-on:click="logout()">
                        <i class="fa fa-sign-out"></i> Log out
                    </a>
                </li>
            </ul>

        </nav>
    </div>
</template>

<script>
    /* eslint-disable */
    import Inputmask from "inputmask";
    export default {
        name: "Header",
        data() {
            return {
                totalNotificationCount: 0,
                contactNumberForNewOrder: "",
                isValidContactNumber: false,
                userRole:''
            }
        },
        created: function () {
            this.loadComplaintCount();
            this.userRole = this.$store.state.user.userRolesById[0].role.split('_')[1];
        },
        mounted: function () {
            // Inputmask({
            //     "mask": "9999-9999999"
            // }).mask($("#top-search"));
        },
        methods: {
            loadComplaintCount: function () {
                this.$http.post(this.$store.state.mainAppURL + "complaints/get_new_complaints_count").then(resp => {
                    this.totalNotificationCount = resp.data;
                });
            },
            logout: function () {
                this.$store.dispatch('logout').then(() => {
                    console.log(this.$state);
                    this.$router.push('/');
                });
            },
            validateContactNumber: function (e){
                let contactNumber = $(e.target).val();
                contactNumber = contactNumber.replace("-","");
                this.isValidContactNumber = !isNaN(contactNumber) && (contactNumber.length === 10 || contactNumber.length === 11);
                if(this.isValidContactNumber){
                    this.contactNumberForNewOrder = contactNumber;
                }
            },
            routeToNewOrder: function () {
                if(!this.isValidContactNumber){
                    return swal("Error!", "Invalid Contact Number!", "error");
                }
                $("#top-search").val("");
                this.$router.push("/new_delivery_order?customer_number="+this.contactNumberForNewOrder);
            },
            toggleNavBar: function () {
                $("body").toggleClass("mini-navbar");
                this.SmoothlyMenu();

            },
            SmoothlyMenu: function () {
                if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {

                    // Hide menu in order to smoothly turn on when maximize menu
                    $('#side-menu').hide();
                    // For smoothly turn on menu
                    setTimeout(
                        function () {
                            $(".m_tip").tooltip("destroy");
                            $('#side-menu').fadeIn(500);
                        }, 100);
                } else if ($('body').hasClass('fixed-sidebar')) {
                    $('#side-menu').hide();
                    setTimeout(
                        function () {
                            $('#side-menu').fadeIn(500);
                        }, 300);
                } else {
                    // Remove all inline style from jquery fadeIn function to reset menu state
                    $('#side-menu').removeAttr('style');
                    $(".m_tip").tooltip({placement:"right"});
                }
            },
        }
    }
</script>

<style scoped>

</style>
